import { CircularProgress, Grid, Typography } from "@mui/material";

function MapLoading({ title }: { title: string }) {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <CircularProgress />
      <Typography>{title}</Typography>
    </Grid>
  );
}

export default MapLoading;
